import { styled } from '@mui/material/styles';
import { Badge, BadgeProps } from '@mui/material';

interface MenuNotificationBadgeProps extends BadgeProps {
    data: number | boolean | undefined | null;
}

const makeStyledMenuNotificationBadge = ({
    height,
    minWidth,
}: {
    height: number;
    minWidth: number;
}) =>
    styled(Badge)<BadgeProps>(({ theme }) => ({
        '& .MuiBadge-badge': {
            color: theme.colors.other.badge.topMenu.color,
            background: theme.colors.other.badge.topMenu.background,
            height,
            minWidth,
            fontSize: '8px',
            padding: '0 2px',
        },
    }));

const StyledMenuNotificationBadge = makeStyledMenuNotificationBadge({ height: 16, minWidth: 16 });
const StyledMenuNotificationBadgeSmall = makeStyledMenuNotificationBadge({
    height: 6,
    minWidth: 6,
});

export const MenuNotificationBadge = ({
    data,
    max,
    overlap,
    invisible,
    children,
    ...props
}: MenuNotificationBadgeProps) => {
    const hasQty = typeof data === 'number';
    const isVisible = !invisible && data && data !== undefined;

    const defaultProps = {
        overlap: overlap || 'rectangular',
        max: max || 99,
        invisible: !isVisible,
        'data-testid': 'notification-badge',
        className: `notificationBadge ${hasQty ? 'notificationBadgeWithQty' : ''}`,
        ...props,
    };

    return hasQty ? (
        <StyledMenuNotificationBadge badgeContent={data} {...defaultProps}>
            {children}
        </StyledMenuNotificationBadge>
    ) : (
        <StyledMenuNotificationBadgeSmall badgeContent={<></>} {...defaultProps}>
            {children}
        </StyledMenuNotificationBadgeSmall>
    );
};
